export default [
  {
    key: "forwardMessageHook",
    label: "label.forwardMessageHook",
    placeholder: "https://example.com/forward",
    type: "text",
    hint: "label.forwardMessageFromChatMe",
    cols: 6,
  },
  {
    key: "forwardMessageHookAuthKey",
    label: "label.forwardMessageHookAuthKey",
    type: "text",
    hint: "label.authorizationKey",
    cols: 6,
  },
  {
    key: "domain",
    class: "d-block",
    label: "label.domain",
    type: "text",
    rules: "required|url",
    hint: "label.chatMeDomain",
    cols: 6,
  },
  {
    key: "appId",
    label: "label.appId",
    type: "text",
    rules: "required",
    hint: "label.chatMeAppId",
    cols: 6,
  },
  {
    key: "appSecret",
    label: "label.appSecret",
    type: "textarea",
    rules: "required",
    hint: "label.chatMeAppSecret",
    cols: 6,
  },
  {
    key: "appKey",
    label: "label.appKey",
    type: "textarea",
    rules: "required",
    hint: "label.chatMeAppKey",
    cols: 6,
  },
  {
    key: "autoJoinPeriod",
    label: "label.autoJoinChatPeriod",
    type: "number",
    rules: "required",
    hint: "label.howLongOperatorCanAutoJoinChatRoom",
    cols: 6,
  },
  {
    key: "isBlockBankOrPhone",
    label: "label.blockPhoneNumberOrBankAccount",
    type: "checkbox",
    cols: 12,
  },
];
